/**
 * @generated SignedSource<<23ae7d2959cdcc1a4cf9d30a69a2166a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise$data = {
  readonly flourishTeams: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationFlourishPraiseLeaderboardItem">;
  }>;
  readonly id: string;
  readonly overviewSize: WidgetOverviewSize;
  readonly " $fragmentType": "WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise";
};
export type WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise$key = {
  readonly " $data"?: WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetIntegrationFlourishPraiseLeaderboardItem",
      "kind": "LinkedField",
      "name": "flourishTeams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIntegrationFlourishPraiseLeaderboardItem"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetIntegrationFlourishPraise",
  "abstractKey": null
};
})();

(node as any).hash = "9da6c2a22fab829a2cef43e198de027f";

export default node;
